import APIClient from '@/shared/http/clients/api'

const resourceName = 'boardcolumn'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=posicao,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/board/${id}/column`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const CreateMany = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/columns`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/board/${data.id}/column`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/board/${id}/column`, config)
const Search = (boardId = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardId=${boardId}&page=${index}&size=${limit}&sort=posicao`, config)

const BoardColumnRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  CreateMany,
  Update,
  Delete,
  Search
}

export default BoardColumnRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/boardcolumn.js